import { render } from "./orderCard_e.vue?vue&type=template&id=b5be7bea"
import script from "./orderCard_e.vue?vue&type=script&lang=js"
export * from "./orderCard_e.vue?vue&type=script&lang=js"

import "./orderCard_e.vue?vue&type=style&index=0&id=b5be7bea&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__